module.exports = "/_next/static/images/photoRodionDanu-a694f29ca6f1dc44cd655ce9136bb3c6.webp";